import { styled, Dialog, dialogClasses, IconButton } from '@mui/material';
import { TabPanel } from '@mui/lab';

export const DialogCreatePartnerCompanyContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 400,
    width: '100%',
  },
});

export const DialogCreatePartnerCompanyHeader = styled('div')(({ theme }) => ({
  flex: 'none',
  padding: theme.spacing(2, 3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const DialogCreatePartnerCompanyCloseIcon = styled(IconButton)(
  ({ theme }) => ({
    color: theme.palette.grey[500],
  }),
);

export const DialogCreatePartnerCompanyTabPanel = styled(TabPanel)({
  display: 'flex',
  flexDirection: 'column',
  padding: 0,
  flex: 1,
});
